import { getSaleProductsWithSequence, setSaleProductsWithSequence } from "api/product";
import React, { useContext, useEffect, useState } from "react";
import SortableHierarchy from "../../../Components/SortableHierarchy";
import { useNavigate } from "react-router-dom";
// Components
import Header from "../../../Components/Header/Header";
import LoadingScreen from "../../../Components/Loading/LoadingScreen";
// Context
import { AppContext } from "../../../Context/AppContext";
import { MODULES } from "../../../Helpers/Constants";
import { getAccessByModuleName } from "../../../Routes/Routes";
import Frame from "./../../../Assets/images/Frame 697@2x.svg";
//scss
import styles from "./index.module.scss";

const SaleProductSequence = (props) => {
  const navigate = useNavigate();
  const { showToastMessage, modules } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [access, setAccess] = useState({});
  const [loading, setLoading] = useState(true);

  const updateData = async () => {
    setLoading(true);
    const postData = {
      data: data,
    };
    const response = await setSaleProductsWithSequence(postData);
    if (response && response.status === 200) {
      showToastMessage(
        undefined,
        "Sequence has been updated successfully.",
        "success",
        false
      );
      fetchData();
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const response = await getSaleProductsWithSequence();
    if (response && response.status === 200) {
      setData(response.data.data.rows);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setLoading(false);
  };

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);

  // Access Contorol functionm call
  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.SALE_PRODUCT);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.write_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }
  const renderItem = ({ collapseIcon, depth, handler, index, item }) => (
    <div>
      <div className={styles.SaleGridTable}>
        <div
          className={
            "d-flex align-items-center justify-cotent-between cursor-pointer ml-3"
          }
        >
          {collapseIcon}
          <img
            style={{ width: "25px", height: "25px" }}
            src={Frame}
            alt="Move"
          />
        </div>
        <div className={styles.ProducatImageWapper}>
          {item.product_images.length !== 0 ? (
            <img
              src={
                item.product_images.length === 0 ||
                item.product_images[0].image === "" ||
                item.product_images[0].image === "null" ||
                item.product_images[0].image === null
                  ? ""
                  : `${item.product_images[0].image}`
              }
              alt={item.title}
            />
          ) : (
            <div className={styles.emptyImage}>
              <span>Image</span>
            </div>
          )}
        </div>
        <div className={styles.Name}>{item.title}</div>
        <div className={styles.Name}>{item.priceRange}</div>
      </div>
    </div>
  );
  const handleProductSequence = async (event) => {
    setData(event.items);
  };

  const SequenceData = () =>
    data && data.length > 0 ? (
      <div>
        <div className="row mb-4">
          <div className={`col-md-6`}>
          </div>
          <div className={`col-md-6`}>
            <span
              onClick={() => {
                updateData();
              }}
              style={{
                fontSize: "14px",
                padding: "7px 15px",
                marginLeft: "76%",
              }}
              className="btn gray-btn d-inline-block mb-2 mr-2 mt-5 cursor-pointer text-right"
            >
              Save Sequence
            </span>
          </div>
        </div>
        <div className={styles.SaleGridTableHeader}>
          <div className={styles.MoveButton}></div>
          <div className={styles.header}>Image</div>
          <div className={styles.header}>Product Name</div>
          <div className={styles.header}>Price</div>
        </div>
        <SortableHierarchy
          className={`${styles.NestedGroup} nestedSequence`}
          items={data}
          renderItem={renderItem}
          onChange={handleProductSequence}
          maxDepth={1}
        />
      </div>
    ) : (
      <div>No data found</div>
    );
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <React.Fragment>
      <Header title="Sale Product Sequence" />
      <div id="MainContent" className="main-content" />
      <div>
        <SequenceData />
      </div>
    </React.Fragment>
  );
};

export default SaleProductSequence;
